const formatNcm = (ncm) => {
  if (ncm) {
    return ncm
      .replace(/\D/g, "")
      .replace(/^(\d{4})(\d{2})(\d{2})$/, "$1.$2.$3");
  }

  return ncm;
};

export default formatNcm;
